import { render } from "./HeaderMessage.vue?vue&type=template&id=4476fab5&scoped=true&ts=true"
import script from "./HeaderMessage.vue?vue&type=script&lang=ts"
export * from "./HeaderMessage.vue?vue&type=script&lang=ts"

import "./HeaderMessage.vue?vue&type=style&index=0&id=4476fab5&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4476fab5"]])

export default __exports__